import { useContext } from 'react'
import BienContext from '@/features/biens/BienContext'
import { formatPrice } from '@/utils/formatters'
import DataContainer from '../../common/DataContainer'
import QuittancesLocataire from './QuittancesLocataire'
// import DocumentsLocataire from './DocumentsLocataire'
import LegalDocumentFiles from '../../common/LegalDocumentFiles'
import DetailsLogement from './DetailsLogement'
import Entretiens from './Entretiens'
import Interventions from './Interventions'
import Activities from '../../common/Activities'
import RibInfo from './RibInfo'

const LocationEnCours = () => {
  const { bien } = useContext(BienContext)
  const location = bien?.location

  return (
    <div className="space-y-6">
      {/* Section principale avec deux colonnes */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        
        <DetailsLogement bien={bien} location={location} />

        <div className='overflow-hidden'>
          <h3 className="text-md font-semibold mb-2">Détails de vos loyers et charges</h3>
          <div className="w-full bg-primary-100 p-4 rounded-none space-y-4 h-full">
            <div className="flex flex-col gap-4">
              <DataContainer
                label="Loyer Hors Charges"
                value={formatPrice(location?.prix_loyer)}
                responsiveGridColsCss='sm:grid-cols-2'
              />
              { location?.montant_charges_syndic &&
                <DataContainer
                  label="Syndic"
                  value={formatPrice(location?.montant_charges_syndic)}
                  responsiveGridColsCss='sm:grid-cols-2'
                />
              }
              { location?.montant_charges_menage_commun && 
                <DataContainer
                  label="Ménage communs"
                  value={formatPrice(location?.montant_charges_menage_commun)}
                  responsiveGridColsCss='sm:grid-cols-2'
                />
              }
              { location?.montant_charges_electricite_commun && 
                <DataContainer
                  label="Electricité communs"
                  value={formatPrice(location?.montant_charges_electricite_commun)}
                  responsiveGridColsCss='sm:grid-cols-2'
                />
              }
              { location?.montant_charges_espaces_verts && 
                <DataContainer
                  label="Entretien espaces verts"
                  value={formatPrice(location?.montant_charges_espaces_verts)}
                  responsiveGridColsCss='sm:grid-cols-2'
                />
              }
              { location?.montant_charges_eau_froide &&
                <DataContainer
                  label="Eau froide (+ assainissement)"
                  value={formatPrice(location?.montant_charges_eau_froide)}
                  responsiveGridColsCss='sm:grid-cols-2'
                />
              }
              { location?.montant_charges_ordures_menageres &&
                <DataContainer
                  label="Taxe d'ordure ménagère"
                  value={formatPrice(location?.montant_charges_ordures_menageres)}
                  responsiveGridColsCss='sm:grid-cols-2'
                />
              }
              { location?.montant_charges_entretien_chauffage &&
                <DataContainer
                  label="Entretien chauffage"
                  value={formatPrice(location?.montant_charges_entretien_chauffage)}
                  responsiveGridColsCss='sm:grid-cols-2'
                />
              }
              <DataContainer
                label="Soit, votre loyer charges comprises"
                value={formatPrice(location?.prix_loyer_charges_comprises)}
                labelCss='font-bold'
                responsiveGridColsCss='sm:grid-cols-2'
              />
            </div>
            <RibInfo />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        {/* Quittances */}
        <QuittancesLocataire />

        {/* Documents */}
        <LegalDocumentFiles />
      </div>

      {/* Historique des entretiens */}
      <Entretiens />

      {/* Historique des interventions */}
      <Interventions />

      {/* Historique des activités */}
      <Activities />
    </div>
  )
}

export default LocationEnCours